import axios from "axios";
import type { AxiosResponse } from "axios";

export interface MailingListSignup {
  email: string;
  firstName: string;
}

export function signUpForMailingList({
  email,
  firstName
}: MailingListSignup): Promise<AxiosResponse> {
  return axios.post("/.netlify/functions/subscribe-to-mailchimp", {
    email,
    firstName
  });
}
